import type { AssignedState } from "../../../components/AssignedStateToggle";

export type RuleSort = "priorityDesc" | "priorityAsc" | "nameAsc";

/**
 * Selector for the "Action touches" filter. Most values map directly to a
 * single `EditActionDto["field"]`; a few are groups:
 *  - `category`   → addCategory or removeCategory
 *  - `attachment` → addAttachment or removeAttachment
 *  - `askUser`    → prompt
 *  - `copyField`  → copies one field's value into another
 */
export type ActionFilter =
  | "any"
  | "source"
  | "merchant"
  | "description"
  | "group"
  | "amount"
  | "expenseType"
  | "datePaid"
  | "category"
  | "attachment"
  | "receipt"
  | "applyAutoTx"
  | "ignore"
  | "askUser"
  | "copyField";

export type Filters = {
  enabled: AssignedState;
  namePattern: string;
  actionField: ActionFilter;
};

export const defaultFilters: Filters = {
  enabled: "any",
  namePattern: "",
  actionField: "any",
};

export const isDefaultFilters = (f: Filters): boolean =>
  f.enabled === "any" && f.namePattern === "" && f.actionField === "any";
